function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("title", null, "Group 3@1x");

var _ref2 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "website",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "experiences-copy",
  transform: "translate(-512.000000, -361.000000)",
  fill: "#CFD3D4",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "Group-14",
  transform: "translate(142.000000, 340.000000)"
}, React.createElement("g", {
  id: "Group-12",
  transform: "translate(370.000000, 21.000000)"
}, React.createElement("g", {
  id: "Group-3"
}, React.createElement("path", {
  d: "M6.42857143,7.99360578e-15 C7.53314093,7.99360578e-15 8.42857143,0.8954305 8.42857143,2 L8.42857143,6.42857143 C8.42857143,7.53314093 7.53314093,8.42857143 6.42857143,8.42857143 L2,8.42857143 C0.8954305,8.42857143 7.99360578e-15,7.53314093 7.99360578e-15,6.42857143 L7.99360578e-15,2 C7.99360578e-15,0.8954305 0.8954305,7.99360578e-15 2,7.99360578e-15 L6.42857143,7.99360578e-15 Z M2,2 L2,6.42857143 L6.42857143,6.42857143 L6.42857143,2 L2,2 Z",
  id: "Rectangle"
}), React.createElement("path", {
  d: "M16,7.99360578e-15 C17.1045695,7.99360578e-15 18,0.8954305 18,2 L18,6.42857143 C18,7.53314093 17.1045695,8.42857143 16,8.42857143 L11.5714286,8.42857143 C10.4668591,8.42857143 9.57142857,7.53314093 9.57142857,6.42857143 L9.57142857,2 C9.57142857,0.8954305 10.4668591,7.99360578e-15 11.5714286,7.99360578e-15 L16,7.99360578e-15 Z M11.5714286,2 L11.5714286,6.42857143 L16,6.42857143 L16,2 L11.5714286,2 Z",
  id: "Rectangle"
}), React.createElement("path", {
  d: "M16,9.57142857 C17.1045695,9.57142857 18,10.4668591 18,11.5714286 L18,16 C18,17.1045695 17.1045695,18 16,18 L11.5714286,18 C10.4668591,18 9.57142857,17.1045695 9.57142857,16 L9.57142857,11.5714286 C9.57142857,10.4668591 10.4668591,9.57142857 11.5714286,9.57142857 L16,9.57142857 Z M11.5714286,11.5714286 L11.5714286,16 L16,16 L16,11.5714286 L11.5714286,11.5714286 Z",
  id: "Rectangle"
}), React.createElement("path", {
  d: "M6.42857143,9.57142857 C7.53314093,9.57142857 8.42857143,10.4668591 8.42857143,11.5714286 L8.42857143,16 C8.42857143,17.1045695 7.53314093,18 6.42857143,18 L2,18 C0.8954305,18 7.99360578e-15,17.1045695 7.99360578e-15,16 L7.99360578e-15,11.5714286 C7.99360578e-15,10.4668591 0.8954305,9.57142857 2,9.57142857 L6.42857143,9.57142857 Z M2,11.5714286 L2,16 L6.42857143,16 L6.42857143,11.5714286 L2,11.5714286 Z",
  id: "Rectangle"
}))))));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref, _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/ico_category.6d8d8b2c.svg";
export { SvgComponent as ReactComponent };